module.exports = __webpack_public_path__ + "static/img/about045.32eb424.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about045.png
// module id = d1Eg
// module chunks = 1